import { render, staticRenderFns } from "./bdMap.vue?vue&type=template&id=94226648&scoped=true"
import script from "./bdMap.vue?vue&type=script&lang=js"
export * from "./bdMap.vue?vue&type=script&lang=js"
import style0 from "./bdMap.vue?vue&type=style&index=0&id=94226648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94226648",
  null
  
)

export default component.exports